import React from 'react'

import { cn } from 'utils/classMerge'

export const LoadingSpinner = ({
  dataTestId,
  className,
  width = 32,
  height = 32,
  color = 'tw-stroke-white',
}: React.JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { dataTestId?: string; color?: string }) => {
  return (
    <svg
      data-testid={dataTestId || 'loading-spinner'}
      className={cn('tw-animate-spin', className, {
        'tw-stroke-white': !className?.includes('tw-stroke-'),
      })}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4C13.6266 4 11.3066 4.70379 9.33316 6.02236C7.35977 7.34094 5.8217 9.21509 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.6936 20.6689 5.83649 22.8071 7.51472 24.4853C9.19295 26.1635 11.3312 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6935 28 18.3734 28 16"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
